<template>
    <div class="commpany-info">
    <headComponents :companyInfo="companyInfoData" />
        <div class="content">
            <div class="content-tabs">
            <van-tabs v-model="active" scrollspy :sticky="scrollTopIos>0 ? false : true" :offset-top="stickyTop" class="tab-style" title-inactive-color="#999999" title-active-color="#333333" color="#398DFF" line-width="20" line-height="2" >
            <van-tab title="基本信息">
                <div class="bg-gray"></div>
                <h3 class="base-title">基本信息</h3>
                <baseInfo v-if="detailInfoArr && detailInfoArr.length>0" @baseInfoForm="baseInfoForm" :params="baseInfoVal" />
            </van-tab>
            <van-tab  title="人力资源">
                <div class="bg-gray"></div>
                <h3 class="base-title">人力资源</h3>
                <div class="info">
                    <div class="label">
            <div class="lable-left">企业人员规模</div>
            <div class="lable-right">
                <van-field
                    class="label-input"
                    v-model="form.employeeNum"
                    autosize
                    label=""
                    type="digit"
                    maxlength="7"
                    @focus="upLoadHandle(340)"
                    @blur="blurHandle"
                    placeholder="请填写"
                    >
                    <template #button>
                        <van-button size="small" type="default">人</van-button>
                    </template>
                </van-field>
            </div>
        </div>
        <div class="label" >
            <div class="lable-left">科技人员数量</div>
            <div class="lable-right">
                <van-field
                    class="label-input"
                    v-model="form.employeeTechNum"
                    autosize
                    label=""
                    type="digit"
                    maxlength="7"
                    placeholder="请填写"
                    @focus="upLoadHandle(390)"
                    @blur="blurHandle"
                    >
                    <template #button>
                        <van-button size="small" type="default">人</van-button>
                    </template>
                </van-field>
            </div>
        </div>
        <div class="label lable-last">
            <div class="lable-left">本科(含)以上学历人数</div>
            <div class="lable-right">
                <van-field
                    class="label-input input-employee"
                    v-model="form.employeeUndergraduateNum"
                    autosize
                    label=""
                    type="digit"
                    maxlength="7"
                    placeholder="请填写"
                    @focus="upLoadHandle(440)"
                    @blur="blurHandle"
                    >
                    <template #button>
                        <van-button size="small" type="default">人</van-button>
                    </template>
                </van-field>
            </div>
        </div>
                </div>
            </van-tab>
            <van-tab title="财务信息">
                <div class="bg-gray"></div>
                <h3 class="base-title">财务信息</h3>
                <financialInfo v-if="detailInfoArr && detailInfoArr.length>0" @financialInfoForm="financialInfoForm"  :params="financialInfoFormInfo"/>
                    <div class="info">
                        <div class="label">
            <div class="lable-left">{{detailInfo.lastYear}}年总资产</div>
            <div class="lable-right">
                <van-field
                    class="label-input"
                    v-model="form.totalAssets"
                    label=""
                    type="number"
                    maxlength="17"
                    placeholder="请填写"
                    @focus="upLoadHandle(620)"
                    @blur="blurHandle"
                    >
                    <template #button>
                        <van-button size="small" type="default">万</van-button>
                    </template>
                </van-field>
            </div>
        </div>
        <div class="label lable-last">
            <div class="lable-left">{{detailInfo.lastYear}}年总负债</div>
            <div class="lable-right">
                <van-field
                    class="label-input"
                    v-model="form.totalDebt"
                    rows="2"
                    autosize
                    label=""
                    type="number"
                    maxlength="17"
                    placeholder="请填写"
                    @focus="upLoadHandle(690)"
                    @blur="blurHandle"
                    >
                    <template #button>
                        <van-button size="small" type="default">万</van-button>
                    </template>
                </van-field>
            </div>
        </div>
                    </div>
            </van-tab>
            <van-tab  title="科研创新">
                <div class="bg-gray"></div>
                <h3 class="base-title">科研创新</h3>
                <!-- <knowledgeInfo v-if=" detailInfoArr && detailInfoArr.length>0"  @knowledgeInfoForm="submitParams" :params="knowledgeInfoForm" /> -->
                <div class="info">
                <div class="label">
                    <div class="lable-left">{{detailInfo.lastYear}}年研发投入</div>
                    <div class="lable-right">
                        <van-field
                            class="label-input"
                            v-model="form.costResearch"
                            rows="2"
                            autosize
                            label=""
                            type="number"
                            maxlength="17"
                            placeholder="请填写"
                            @focus="upLoadHandle(840)"
                            @blur="blurHandle"
                            >
                            <template #button>
                                <van-button size="small" type="default">万</van-button>
                            </template>
                        </van-field>
                    </div>
            </div>
            <div class="label">
                    <div class="lable-left">{{detailInfo.lastYear}}年设备投入</div>
                    <div class="lable-right">
                        <van-field
                            class="label-input"
                            v-model="form.costNewequip"
                            rows="2"
                            autosize
                            label=""
                            type="number"
                            maxlength="17"
                            placeholder="请填写"
                            @focus="upLoadHandle(860)"
                            @blur="blurHandle"
                            >
                            <template #button>
                                <van-button size="small" type="default">万</van-button>
                            </template>
                        </van-field>
                    </div>
            </div>
             <div class="label">
                    <div class="lable-left">发明专利数量</div>
                    <div class="lable-right">
                        <van-field
                            class="label-input"
                            v-model="form.patentNum"
                            rows="2"
                            autosize
                            label=""
                            type="digit"
                            maxlength="7"
                            placeholder="请填写"
                            @focus="upLoadHandle(910)"
                            @blur="blurHandle"
                            >
                            <template #button>
                                <van-button size="small" type="default">个</van-button>
                            </template>
                        </van-field>
                    </div>
            </div>
            <div class="label">
                    <div class="lable-left">实用新型数量</div>
                    <div class="lable-right">
                        <van-field
                            class="label-input"
                            v-model="form.patentPracticalNum"
                            autosize
                            label=""
                            type="digit"
                            maxlength="7"
                            placeholder="请填写"
                            @focus="upLoadHandle(960)"
                            @blur="blurHandle"
                            >
                            <template #button>
                                <van-button size="small" type="default">个</van-button>
                            </template>
                        </van-field>
                    </div>
            </div>
             <div class="label">
                    <div class="lable-left">外观专利数量</div>
                    <div class="lable-right">
                        <van-field
                            class="label-input"
                            v-model="form.patentAppearanceNum"
                            autosize
                            label=""
                            type="digit"
                            maxlength="7"
                            placeholder="请填写"
                            @focus="upLoadHandle(1100)"
                            @blur="blurHandle"
                            >
                            <template #button>
                                <van-button size="small" type="default">个</van-button>
                            </template>
                        </van-field>
                    </div>
            </div>
            <div class="label">
                    <div class="lable-left">软件著作权数量</div>
                    <div class="lable-right">
                        <van-field
                            class="label-input"
                            v-model="form.softwareNum"
                            autosize
                            label=""
                            type="digit"
                            maxlength="7"
                            placeholder="请填写"
                            @focus="upLoadHandle(1150)"
                            @blur="blurHandle"
                            >
                            <template #button>
                                <van-button size="small" type="default">个</van-button>
                            </template>
                        </van-field>
                    </div>
            </div>
            </div>
            </van-tab>
            </van-tabs>
            </div>
            <div class="space-block"></div>
            <div class="footer">
            <div class="brief">部分数据来自国家企业信用信息公示系统</div>
            <div class="submit-button" @click="submitForm">{{saveBtnText}}</div>
            </div>
        </div>
    </div>
    
</template>
<script>
import headComponents from "@/components/companyinfo/head.vue"
import baseInfo from "@/components/companyinfo/baseInfo.vue"
import financialInfo from "@/components/companyinfo/financialInfo.vue"
import { companyInfo,companyUpdate } from "@/api/api_company.js"
export default {
    components:{
        headComponents,
        baseInfo,
        financialInfo,
    },
    data(){
        return{
            baseInfoVal:{},
            active: 0,
            financialInfoFormInfo:{},
            knowledgeInfoForm:{},
            detailInfoArr:[],
            detailInfo:{},
            companyInfoData:{},
            saveBtnText:"去匹配政策",
            isSaveData:false,
            form:{
                employeeNum:"",
                employeeTechNum:"",
                employeeUndergraduateNum:"",
                totalAssets:'',
                totalDebt:'',
                costResearch:'',
                costNewequip:'',
                softwareNum:'',
                patentAppearanceNum:'',
                patentNum:'',
                patentPracticalNum:'',
                showNavbar:false,
            },
            scrollTopIos:0
            
        }
    },
created(){
	this.showNavbar = Number(localStorage.getItem('clearNav')) === 1 ? true : false
},
computed:{
    stickyTop(){
    return this.showNavbar ? localStorage.getItem('navBarHeight')-4 : 0
    }
},
    mounted(){
        this.loadata()
    },
    beforeRouteLeave (to, from, next) {
        if(to.path === '/home') {
            if(this.isSaveData){
                to.query.from = 'companyinfo'
            }
            next()
        }else{
            next()
        }
    },
    methods:{
        blurHandle(){
            window.onresize = null; 
            this.scrollTopIos =0
        },
        upLoadHandle(offetTopNum){
             let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            //解决安卓手机软键盘挡住input输入框
            if (/Android/gi.test(navigator.userAgent)) {
                window.onresize = function () {
                if (document.activeElement.tagName == "INPUT") {
                    setTimeout(function () {
                        window.scrollTo(0,offetTopNum);
                    }, 0);
                }
            }
            }else if(isiOS){
                //解决ios键盘弹出fixed定位失效问题，手机机制问题，键盘弹起去掉fixed定位
                this.scrollTopIos = document.body.scrollTop || document.documentElement.scrollTop;
                console.log('scrollTopIos',this.scrollTopIos)
            }
        },
        
        baseInfoForm(val){
            this.baseInfoVal=val
            console.log('baseInfoForm',val)
        },
        submitForm(){
            let {cateType,provinceId}=this.detailInfo
            provinceId= this.baseInfoVal.provinceId || provinceId
            cateType= this.baseInfoVal.cateType || cateType
        if(!provinceId){
            this.$toast('请选择企业注册地');
            return false;
        }
        if(!cateType){
            this.$toast('请选择所属领域');
            return false;
        }
        if(parseInt(this.form.employeeNum)===0){
        this.$toast('企业人员规模不能为0哦~')
        return false
        }else if(parseInt(this.form.employeeNum)<0){
            this.$toast('企业人员规模不能为负数哦~')
        return false
        }
        if(parseInt(this.form.employeeTechNum)===0){
        this.$toast('科技人员数量不能为0哦~')
        return false
        }else if(parseInt(this.form.employeeTechNum)<0){
            this.$toast('科技人员数量不能为负数哦~')
        return false
        }
        if(parseInt(this.form.employeeUndergraduateNum)===0){
        this.$toast('本科(含)以上学历人数不能为0哦~')
        return false
        }else if(parseInt(this.form.employeeUndergraduateNum)<0){
            this.$toast('本科(含)以上学历人数不能为负数哦~')
        return false
        }
        let valueOneArr=this.form.totalAssets.split('.')
        let valueTwoArr=this.form.totalDebt.split('.')
        if(valueOneArr[1] && valueOneArr[1].length>4){
        this.$toast('总资产最多输入四位小数哦~')
        return false
        }
        if(valueTwoArr[1] && valueTwoArr[1].length>4){
            this.$toast('总负债最多输入四位小数哦~')
            return false
        }
        if(this.form.costResearch){
            let costResearch=this.form.costResearch.split('.')
            if(costResearch[1] && costResearch[1].length>4){
                this.$toast(`${this.detailInfo.lastYear}年的研发收入最多输入四位小数哦~`)
                return false
                }else if(this.form.costResearch<0){
                    this.$toast(`${this.detailInfo.lastYear}年的研发不能为负数哦~`)
                    return false
                }
            }
            if(this.form.costNewequip){
                let costNewequip=this.form.costNewequip.split('.')
                if(costNewequip[1] && costNewequip[1].length>4){
                    this.$toast(`${this.detailInfo.lastYear}年设备投入最多输入四位小数哦~`)
                    return false
                }else if(this.form.costNewequip<0){
                    this.$toast(`${this.detailInfo.lastYear}年设备投入不能负数哦~`)
                    return false
                }
            }
            if(this.form.patentNum<0){
                this.$toast(`发明专利数量不能为负数哦~`)
                return false;
            }
            if(this.form.patentPracticalNum<0){
                this.$toast(`实用新型数量不能为负数哦~`)
                return false;
            }
            if(this.form.patentAppearanceNum<0){
                this.$toast(`外观专利数量不能为负数哦~`)
                return false;
            }
            if(this.form.softwareNum<0){
                this.$toast(`软件著作权数量不能为负数哦~`)
                return false;
            }
            let params=this.form
            params.entryType=2
            if(this.baseInfoVal.cateList){
                delete  this.baseInfoVal.cateList
            }
            Object.assign(params,this.financialInfoFormInfo,this.knowledgeInfoForm,this.baseInfoVal)
            companyUpdate(params).then(res=>{
                if(res.ok===true){
                    this.isSaveData=true
                    this.$toast('保存成功')
                    this.$store.dispatch('getMyPageInfo');
                    this.$router.push({
                            path:'/home',
                            query:{from:'companyinfo'}
                        })
                }
            })
        },
        financialInfoForm(val){
            this.financialInfoFormInfo=val
        },
        submitParams(val){
            this.knowledgeInfoForm=val
        },
        loadata(){
            companyInfo().then(res=>{
                if(res.ok===true){
                    let {data}=res
                        this.detailInfoArr=data && Object.keys(data)
                    this.detailInfo=data
                    if(data){
                    let detailInfo=data
                    this.form=detailInfo
                    this.companyInfoData={
                        companyName:detailInfo.companyName,
                        materialCompleteRate:detailInfo.materialCompleteRate
                    }
                    let baseInfoVal={
                        maxCate:detailInfo.maxCate,
                        provinceId:detailInfo.provinceId,
                        cityId:detailInfo.cityId,
                        regionId:detailInfo.regionId,
                        cateList:detailInfo.cateList,
                        cateType:detailInfo.cateType,
                        foundDate:detailInfo.foundDate,
                        isHighTechCountry:detailInfo.isHighTechCountry,
                        isHighTechRegion:detailInfo.isHighTechRegion,
                        highTechYearCountry:detailInfo.highTechYearCountry,
                        highTechYearRegion:detailInfo.highTechYearRegion,
                        registrationAddr:detailInfo.registrationAddr
                    }
                    this.baseInfoVal=baseInfoVal
                    this.financialInfoFormInfo={
                        totalRevenue:detailInfo.totalRevenue,
                        lastYear:detailInfo.lastYear
                    }
                    }

                }

            })
        }
    },
}
</script>
<style lang="less">
 .info{
        padding: 0 20px;
        margin:0 12px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        height: 100%;
        background: #fff;
        .label-input{
            padding: 0px;
            font-size: 15px;
        }
        .input-employee{
            padding: 0 0 0 30px;
        }
        /deep/ .van-button--small{
            font-size: 15px;
            color: #888888;
            padding: 0;
        }
        /deep/ .van-field__control{
            color: #888888;
        }
        .label-box{
            flex: 1;
            padding-top: 10px;
        }
        .label{
            height: 50px;
            display: flex;
            justify-content: flex-start;
            font-size:15px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:@darkBlack;
            line-height:50px;
            position: relative;
            align-items: center;
            &::after{
                    position: absolute;
                    box-sizing: border-box;
                    content: ' ';
                    pointer-events: none;
                    top: -50%;
                    right: -50%;
                    bottom: -50%;
                    left: -50%;
                    border-bottom: 1px solid #EEEEEE;
                    -webkit-transform: scale(.5);
                    transform: scale(.5);
            }
            .lable-left {
                width:56%;
                .required-star{
                    color: #FA5151;
                    margin: 0;
                    padding: 0;
                    display: inline-block;
                    font-size: inherit;
                }
            }
            .lable-right{
                display: flex;
                align-items: center;
                color: #888888;
                justify-content: center;
                position: relative;
                width:60%;
                span{
                    line-height: 16px;
                    display: inline-block;
                }
                .category-text{
                    display: inline-block;
                    max-width: 222px;
                }
                .placeholder{
                    color: @lightBlack;
                }
                .right-icon{
                font-size: 14px;
                color: @lightBlack;
                margin: 0 0 0 0px;
                display: inline-block;
            }
            }
        }
        .lable-last::after{
            border-bottom: 0;
        }
    }
    .submit-button{
        width:343px;
        height:40px;
        background:rgba(57,141,255,1);
        border-radius:5px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:40px;
        text-align: center;
        margin: 0 auto 25px;
    }
</style>
<style lang="less" scoped>
    /deep/ .van-tabs--line .van-tabs__wrap{
        height: 50px;
    }
    /deep/ .van-tabs__wrap{
        padding: 0 15px;
    }

/deep/ .van-tab{
    font-size: 16px;
}
/deep/ .van-tab--active{
    font-size: 18px;
}
/deep/ .van-button--default{
            border:0 !important;
        }
.commpany-info{
    height: 100%;
    // overflow-x: hidden;
}
.content{
width:375px;
background:rgba(255,255,255,1);
border-radius:12px 12px 0px 0px;
margin-top:-12px;
position: relative;
padding-top:0;
display: flex;
flex-direction: column;
flex-wrap: wrap;
/deep/ .van-hairline--top-bottom::after{
    border-top:0;
    border-bottom: 0;
}
.content-tabs{
    flex: 1;
    .bg-gray{
        background: RGBA(251, 251, 251, 1);
        height: 20px;
    }
    /deep/ .van-tabs__content{
            background: #fbfbfb;
    }
    /deep/ .van-tab__pane{
box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
border-radius: 5px;
    }
    .base-title{
        font-size: 15px;
        font-weight: 600;
        margin:0 12px;
        height: 50px;
        line-height: 50px;
        position: relative;
        background: #fff;
        padding: 0 20px;
    }
    .base-title::after{
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        top: -50%;
        right: -50%;
        bottom: -50%;
        left: -50%;
        border-bottom: 1px solid #EEEEEE;
        -webkit-transform: scale(.5);
        transform: scale(.5);
    }
}
}
.space-block{
    height: 88px;
}
.footer{
    position: fixed;
    width:375px;
height:88px;
background:rgba(255,255,255,1);
box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
left: 0;
right: 0;
bottom: 0;
}
.brief{
    font-size:12px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(153,153,153,1);
line-height:12px;
text-align: center;
margin: 10px 0;
}
</style>
